import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[color:var(--bg-charcoal)] text-white relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 halftone-bg opacity-[0.08] halftone-fade" aria-hidden="true" />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo-transparent.png" alt="Jyoti Graphics USA" className="h-8 w-auto invert brightness-0" style={{ filter: "invert(1) brightness(2)" }} />
            </div>
            <h3 className="font-display text-[42px] md:text-[64px] leading-[1.05] mt-8 tracking-tight">
              Let's make<br /><em className="italic text-[color:var(--text-inv-2)]">something worth printing.</em>
            </h3>
            <Link
              to="/quote"
              className="btn-accent mt-10 inline-flex items-center gap-3 rounded-full pl-6 pr-5 py-3.5 text-[13px] tracking-[0.16em] uppercase font-medium"
              data-testid="footer-quote-cta"
            >
              Request a Free Quote <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[color:var(--text-inv-2)] mb-6">Navigate</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link to={n.href} className="link-underline text-lg">{n.label}</Link>
                </li>
              ))}
              <li><Link to="/quote" className="link-underline text-lg text-[color:var(--accent)]">Request a Quote</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[color:var(--text-inv-2)] mb-6">Contact</div>
            <ul className="space-y-4 text-[15px]">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-[color:var(--text-inv-2)]" />
                <a href={SITE.phoneHref} data-testid="footer-phone" className="link-underline">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-[color:var(--text-inv-2)]" />
                <a href={SITE.emailHref} data-testid="footer-email" className="link-underline break-all">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[color:var(--text-inv-2)]" />
                <span>{SITE.addressLines[0]}<br />{SITE.addressLines[1]}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-1 text-[color:var(--text-inv-2)]" />
                <span>{SITE.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-6 gap-4 text-[11px] font-mono tracking-[0.14em] uppercase text-[color:var(--text-inv-2)]">
          {SERVICES.map(s => <span key={s.slug}>{s.title}</span>)}
        </div>

        <div className="mt-12 flex flex-col md:flex-row justify-between gap-4 text-[11px] font-mono tracking-[0.16em] uppercase text-[color:var(--text-inv-2)]">
          <div>© {new Date().getFullYear()} Jyoti Graphics USA — All rights reserved</div>
          <div>{SITE.legal}</div>
        </div>
      </div>
    </footer>
  );
}
